import { useEffect, useState } from 'react';
import adminWhatsAppService from '../../services/adminWhatsAppService';

/**
 * Tells staff when WhatsApp is not configured or sending is switched off on this environment.
 * A failed status call shows nothing: the banner is a hint, never a reason to block the page.
 */
const StatusBanner = () => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let active = true;
    adminWhatsAppService
      .getStatus()
      .then((result) => active && setStatus(result))
      .catch(() => {}); // deliberately quiet: no banner, no toast
    return () => {
      active = false;
    };
  }, []);

  let message = '';
  if (status && !status.configured) message = 'WhatsApp is not configured yet. See WHATSAPP_OPS_CHECKLIST.md';
  else if (status && !status.send_enabled) {
    message = 'Sending is switched off on this environment; campaigns can be prepared but nothing is sent';
  }
  if (!message) return null;

  return (
    <div
      role="status"
      data-testid="status-banner"
      className="px-4 py-3 text-sm text-amber-900 dark:text-amber-300 bg-amber-50 dark:bg-amber-950/50 border border-amber-200 dark:border-amber-900 rounded-lg"
    >
      {message}
    </div>
  );
};

export default StatusBanner;
